import { render, staticRenderFns } from "./ProfileSidebarMobile.vue?vue&type=template&id=b8c2f38a"
import script from "./ProfileSidebarMobile.vue?vue&type=script&lang=js"
export * from "./ProfileSidebarMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports